import { useContext } from 'react'
import { InputThemeContext } from 'components/features/theme/InputThemeContext'

export const useInputTheme = () => {
  return useContext(InputThemeContext)
}
